import { declareParams, JsonApiRequestError } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createStore, Store } from 'effector';
import { RegistryParams, RegistryQuery } from 'shared/lib';
import { createAuthQuery } from '../auth-http-client';
import { Cashdesk, cashdeskSchema, createPaginatedSchema } from '../types';

export type OriginalCashdeskRegistryParams = {
	sortField?: string | null;
	sortDirection?: string;
	page?: number;
	limit?: number;
	name?: string;
	currencies?: string[];
	accountIds?: string[];
};

export type CashdeskRegistryFilters = {
	name: string;
	currencies: string[];
	accountIds: number[];
};

export type CashdeskRegistryParams = RegistryParams<CashdeskRegistryFilters>;

export type CashdeskRegistryQuery = RegistryQuery<
	Cashdesk,
	CashdeskRegistryFilters,
	JsonApiRequestError
>;

export const createCashdeskRegistryQuery = (
	$accountId?: Store<number | null>,
): CashdeskRegistryQuery => {
	const query = createAuthQuery({
		params: declareParams<CashdeskRegistryParams>(),
		request: {
			method: 'GET',
			url: '/cashdesk/list',
			query: {
				source: $accountId ?? createStore<number | null>(null),
				fn: (params, accountsId) => ({
					page: params.page,
					limit: params.limit,
					sortField: params.sortField ?? undefined,
					sortDirection: params.sortDirection,
					name: params.filters.name ?? undefined,
					currencies:
						params.filters.currencies?.length === 0 ? undefined : params.filters.currencies,
					accountIds: [
						...(accountsId ? [String(accountsId)] : []),
						...params.filters.accountIds.map(String),
					],
				}),
			},
		},
		response: {
			contract: zodContract(createPaginatedSchema(cashdeskSchema)),
		},
	});

	return query;
};
